import { FileWithPayload } from "commons/types/api/common";

import { AttachmentType } from "components/ui/AttachmentPicker";

import {
    AdvancedListRequest,
    FilterAnd,
    FilterEqType,
    FilterLikeType,
    FilterOr,
    FilterType,
} from "types/api/commons";

export const emptyListRequest = {
    filter: "[]",
    sort: null,
    i: 0,
    page: 0,
    size: 0,
};

export function createAttachmentType({
    id = null,
    label,
    filename = "",
    content = "",
    contentType = null,
    status = 0,
    size = null,
}: {
    id?: string | null;
    label: string;
    filename?: string;
    content?: string;
    contentType?: string | null;
    status?: 0 | 1 | 2;
    size?: number | null;
}): AttachmentType {
    return {
        id,
        filename,
        content,
        contentType,
        size,
        label,
        status,
    };
}

export function converterAttachmentToFileWithPayload(
    file: AttachmentType,
): FileWithPayload | undefined {
    if (file && file.status === 1) {
        return {
            filename: file.filename ?? "",
            file_content: file.content ?? "",
            content_type: file.contentType ?? undefined,
        };
    }

    return undefined;
}

export const calculateStatus = (name: string, content: string) => (name && content ? 1 : 0);

export const createAdvancedListRequestFromFilter = (
    filter: any,
    sort?: string,
): AdvancedListRequest => {
    return {
        sort: sort ?? null,
        filter: "",
        i: 0,
        page: 0,
        size: 0,
        filterAdvanced: JSON.stringify(filter),
    };
};

export const filterEq = (field: string, value: string | number | boolean): FilterEqType => {
    return {
        field,
        value,
        operator: "eq",
    };
};

export const filterLike = (field: string, value: string | number | boolean): FilterLikeType => {
    return {
        field,
        value,
        operator: "like",
    };
};

export const filterAnd = (conditions: Array<FilterType<unknown>>): FilterAnd => {
    return {
        operator: "and",
        conditions,
    };
};

export const filterOr = (conditions: Array<FilterType<unknown>>): FilterOr => {
    return {
        operator: "or",
        conditions,
    };
};

export const firstLetterUpperCase = (value: string) =>
    value.charAt(0).toUpperCase() + value.slice(1);
